<mat-accordion>
  <!-- TECHNICAL SHEET -->
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>{{'COMMON.LABEL.TECHNICAL_SHEET' | translate }}</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="row">
      <ng-container *ngFor="let vehicleTechnicalProperty of vehicleTechnicalProperties; let index = index">
        <div class="col-12 my-2 px-1">

          <span *ngIf="vehicleTechnicalProperty.keyBefore"
            class="key text-capitalize">{{vehicleTechnicalProperty.translationKey | translate
            }}</span>

          <span class="value"
            *ngIf="vehicleTechnicalProperty.enumTranslationKey && garage[vehicleTechnicalProperty.propertyKey]">
            {{vehicleTechnicalProperty.enumTranslationKey +
            garage[vehicleTechnicalProperty.propertyKey] |
            translate }}
          </span>
          <span class="value"
            *ngIf="!vehicleTechnicalProperty.enumTranslationKey">
            {{ garage[vehicleTechnicalProperty.propertyKey] }}
          </span>

          <span *ngIf="!vehicleTechnicalProperty.keyBefore"
            class="key text-capitalize">{{vehicleTechnicalProperty.translationKey | translate
            }}</span>
        </div>

        <!-- <mat-divider class="col-24 d-none d-sm-block"
          *ngIf="(index + 1) % 3 === 0">
        </mat-divider> -->
        <mat-divider class="col-24"
          *ngIf="(index + 1) % 2 === 0">
        </mat-divider>
      </ng-container>
    </div>
  </mat-expansion-panel>

  <!-- DESCRIPTION -->
  <div *ngIf="garage.vehicleStatusDescription">
    <h3 class="mt-3 mb-1 font-weight-bold">{{'COMMON.LABEL.VEHICLE_STATUS_DESCRIPTION' | translate }}</h3>
    <div [innerHTML]="garage.vehicleStatusDescription"></div>
  </div>

  <!-- <mat-expansion-panel *ngIf="garage.vehicleStatusDescription">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>{{'COMMON.LABEL.VEHICLE_STATUS_DESCRIPTION' | translate }}</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p [innerHTML]="garage.vehicleStatusDescription"></p>
  </mat-expansion-panel> -->

  <!-- HISTORICAL DESCRIPTION -->
  <!-- <mat-expansion-panel *ngIf="garage.description">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{'COMMON.LABEL.VEHICLE_HISTORY' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      {{garage.description}}
    </p>
  </mat-expansion-panel>
</mat-accordion> -->

  <div class="d-sm-none"
    *ngIf="garage.description">
    <h3 class="mt-3 mb-1">{{'COMMON.LABEL.VEHICLE_HISTORY' | translate }}</h3>
    <p>{{garage.description}}</p>
  </div>